/**
 * Opens a video modal when a product image badge with a `data-video-url`
 * is clicked. Used on product pages (snippets/product-badge-image.liquid).
 */
(function () {
  function toEmbedUrl(url) {
    if (!url) return url;
    var match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/
    );
    if (match) return 'https://www.youtube.com/embed/' + match[1];
    return url;
  }

  function openModal(videoUrl) {
    var modalOverlay = document.createElement('div');
    modalOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      box-sizing: border-box;
    `;

    var modalContent = document.createElement('div');
    modalContent.style.cssText = `
      position: relative;
      max-width: 926px;
      width: 100%;
      background: white;
      border-radius: 8px;
      overflow: hidden;
    `;

    var closeButton = document.createElement('button');
    closeButton.innerHTML = '&times;';
    closeButton.setAttribute('aria-label', 'Close video');
    closeButton.style.cssText = `
      position: absolute;
      top: 10px;
      right: 15px;
      background: rgba(0, 0, 0, 0.7);
      color: white;
      border: none;
      font-size: 24px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      cursor: pointer;
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
    `;

    var iframe = document.createElement('iframe');
    iframe.src = toEmbedUrl(videoUrl);
    iframe.title = 'Product video';
    iframe.frameBorder = '0';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    iframe.style.cssText = `
      width: 100%;
      height: 521px;
      max-height: 70vh;
      border: none;
    `;

    modalContent.appendChild(closeButton);
    modalContent.appendChild(iframe);
    modalOverlay.appendChild(modalContent);
    document.body.appendChild(modalOverlay);

    function closeModal() {
      if (modalOverlay.parentNode) {
        document.body.removeChild(modalOverlay);
      }
      document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') closeModal();
    }

    closeButton.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', function (e) {
      if (e.target === modalOverlay) closeModal();
    });
    document.addEventListener('keydown', onKeydown);
  }

  function init() {
    var productBadges = document.querySelectorAll('.product-badge--image-item');
    productBadges.forEach(function (productBadge) {
      var videoUrl = productBadge.dataset.videoUrl;
      if (!videoUrl) return;
      productBadge.addEventListener('click', function () {
        openModal(videoUrl);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
